import { MediaFileTypes } from '@shared/config/media';
import type { MediafilePresentationSource } from './types';

export const getMediafilePresentationKind = ({ type, duration }: MediafilePresentationSource): 'video' | 'image' => {
  if (type === MediaFileTypes.VIDEO || type === MediaFileTypes.VIDEO_PROMO) return 'video';
  if (type === MediaFileTypes.IMAGE || type === MediaFileTypes.IMAGE_PROMO) return 'image';

  // Partial legacy metadata keeps the existing presentation fallback, not preview eligibility.
  return duration ? 'video' : 'image';
};
